import styles from 'styles/Tournaments.module.css';
import DefaultThumbnail from 'assets/images/news/AREA_CUP_logo_original.png';
import ZenkaiThumbnail from 'assets/images/tournaments/zenkai.png';
import CanvasCupThumbnail from 'assets/images/tournaments/canvas_cup.png';
import TitleLineLeft from 'assets/images/tournaments/title_line_left.png'
import MobileTitleLineLeft from 'assets/images/tournaments/mobile_title_line_left.svg'
import TitleLineRight from 'assets/images/tournaments/title_line_right.png'
import MobileTitleLineRight from 'assets/images/tournaments/mobile_title_line_right.svg'
import ACLogo from 'assets/images/tournaments/ac_logo_black.svg'
import ZKLogo from 'assets/images/tournaments/zk_logo_black.svg';
import CALogo from 'assets/images/tournaments/ca_logo_black.svg';
import TopTournament from 'assets/images/tournaments/top_tournament.png'
import ZenkaiTitle from 'assets/images/tournaments/zenkai_title.svg'

const Tournaments = () => {
  return (
    <>
      <div className={styles["tournament-background"]} id="tournaments">
        <div className={styles["top"]}>
          <img src={TopTournament} draggable="false" alt="大会種類"/>
        </div>
        <div className={styles["areacup-container"]}>
          <div className={styles["areacup-image"]}>
            <img src={DefaultThumbnail} alt="AREA CUP"/>
          </div>
          <div className={styles["areacup-catch-copy"]}>
            <img src={TitleLineLeft} className={styles["areacup-title-line"]} draggable="false" />
            <img src={MobileTitleLineLeft} className={styles["areacup-title-line-mobile"]} draggable="false" />
            <img src={ACLogo} className={styles["areacup-background-image"]} draggable="false" alt="AREA CUP"/>
            <h3>ここが<span style={{ color: "#bf0178" }}>エリア</span>の最高峰</h3>
            <p className={styles["areacup-title"]}>AREA CUP</p>
          </div>
        </div>
        <div className={styles["zenkai-container"]}>
          <div className={styles["zenkai-catch-copy"]}>
            <img src={TitleLineRight} className={styles["zenkai-title-line"]} draggable="false" />
            <img src={MobileTitleLineRight} className={styles["zenkai-title-line-mobile"]} draggable="false" />
            <img src={ZKLogo} className={styles["zenkai-background-image"]} draggable="false" alt="独闘祭"/>
            <h3 className={styles["zenkai-catch-copy-1"]}><span className={styles["line"]}></span>いま、</h3>
            <h3 className={styles["zenkai-catch-copy-2"]}>最強の<span style={{ color: "#c8321d" }}>個人</span>を決めよう。</h3>
            <img src={ZenkaiTitle} className={styles["zenkai-title"]} alt="独闘祭" />
          </div>
          <div className={styles["zenkai-image"]}>
            <img src={ZenkaiThumbnail} alt="独闘祭"/>
          </div>
        </div>
        <div className={styles["canvascup-container"]}>
          <div className={styles["canvascup-image"]}>
            <img src={CanvasCupThumbnail} alt="CANVAS CUP"/>
          </div>
          <div className={styles["canvascup-catch-copy"]}>
            <img src={TitleLineLeft} className={styles["canvascup-title-line"]} draggable="false" />
            <img src={MobileTitleLineLeft} className={styles["canvascup-title-line-mobile"]} draggable="false" />
            <img src={CALogo} className={styles["canvascup-background-image"]} draggable="false" alt="CANVAS CUP" />
            <h3>盤面を制して勝利を描け</h3>
            <p className={styles["canvascup-title"]}>CANVAS CUP</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tournaments;
